import { AxiosResponse } from 'axios';

import { IEmployee } from '@entities/myTeam/model/types';
import { $api } from '@shared/api';
import { IDataResponse, IDataResponseError } from '@shared/model/types/dataResponse.inteface';

type AddEmployeeResponse = IDataResponse<IEmployee> | IDataResponseError;
interface IAddEmployee {
    email: string;
    position: string;
    phone: string;
}

export const addEmployee = async ({
    email,
    position,
    phone,
}: IAddEmployee): Promise<AxiosResponse<AddEmployeeResponse>> => {
    // @ts-ignore
    const url = routable.getRoute('addEmployee');
    const formData = new FormData();
    formData.append('email', email);
    formData.append('position', position);
    formData.append('phone', phone);

    try {
        return await $api.post<AddEmployeeResponse>(url, formData);
    } catch (error) {
        return error.response;
    }
};
